module.exports = __webpack_public_path__ + "img/descImg.2459f868.png";